import React from 'react';
import {multiMoney} from '../api/multiples';

export default function MultiplesPayout({estimate,auto=false}:{estimate:any,auto?:boolean}){
 const known=typeof estimate?.payout_cents==='number';
 const final=estimate?.final===true;
 return <section className="multiple-payout" aria-label="Multiple payout" aria-live="polite">
  <div><span>{final?'Final payout':'Estimated payout'}</span><strong>{known?multiMoney(estimate.payout_cents):'Awaiting prices'}</strong></div>
  {known&&<div><span>{final?'Net profit / loss':'Estimated net profit'}</span><strong>{multiMoney(estimate.profit_cents)}</strong></div>}
  <small>{final?'Includes returned stake or liability, after settlement fees.':<>
   Includes returned stake or liability. Assumes remaining legs win, with 10% commission on their profit. BSP and final fees may differ.
   {auto?' Updates every 10 seconds using confirmed returns and prices for remaining legs. Paused slips assume they resume; stopped combinations retain their funds.':''}
   {!!estimate?.settled_legs&&<> {estimate.settled_legs} leg{estimate.settled_legs===1?'':'s'} settled.</>}
   {!known&&<> {estimate?.unavailable_reason||'A price is needed for each remaining leg.'}</>}
  </>}</small>
 </section>;
}
